import { cast, Instance, SnapshotOut, types } from 'mobx-state-tree'

import { withRootStore } from '../extensions'

export const LiveEventModel = types.model('LiveEventModel').props({
  eventName: types.string,
  date: types.string
})
export interface LiveEventModelType extends Instance<typeof LiveEventModel> {}

/**
 * Monday Store Model
 */
export const MondayStore = types
  .model('MondayStore')
  .props({
    inPersonEvents: types.optional(types.array(LiveEventModel), []),
    virtualEvents: types.optional(types.array(LiveEventModel), []),
    selectedEventData: types.maybe(LiveEventModel)
  })
  .extend(withRootStore)
  .views((self) => ({
    get numberOfDaysPassedPostEvent(): number {
      if (self.selectedEventData) {
        const today = new Date() // Today's date
        const eventDate = new Date(self.selectedEventData?.date) // The specific date
        // Calculate the time difference in milliseconds
        const differenceInMs = eventDate.getTime() - today.getTime()
        // Convert the time difference to days
        const differenceInDays = Math.abs(Math.ceil(differenceInMs / (1000 * 60 * 60 * 24)))
        console.log(`The difference is ${differenceInDays} day(s).`)
        return differenceInDays
      }
      return -1
    },
    getInPersonEvents(): LiveEventModelType[] {
      return self.inPersonEvents ?? []
    },
    getVirtualEvents(): LiveEventModelType[] {
      return self.virtualEvents ?? []
    }
  }))
  .actions((self) => ({
    setSelectedEventData(eventData: LiveEventModelType) {
      console.log('setSelectedEvent: ', eventData)
      self.selectedEventData = eventData
    },
    setInPersonEvents(events: LiveEventModelType[]) {
      self.inPersonEvents.replace(events)
    },
    setVirtualEvents(events: LiveEventModelType[]) {
      self.virtualEvents.replace(events)
    }
  }))
  .actions((self) => ({
    async fetchMondayEvents() {
      try {
        console.log('inPersonEvents')
        const inPersonEvents = await self.rootStore.api.queryGetInPersonEvents()
        const virtualEvents = await self.rootStore.api.queryGetVirtualEvents()
        console.log('inPersonEvents: ', inPersonEvents)
        self.setInPersonEvents(inPersonEvents.getInPersonEvents)
        self.setVirtualEvents(virtualEvents.getVirtualEvents)
      } catch (error) {
        console.log('fetchMondayEvents error', error)
      }
    }
  }))

/**
 * The MondayStore instance.
 */
export type MondayStoreType = Instance<typeof MondayStore>

/**
 * The data of a MondayStore.
 */
export type MondayStoreSnapshot = SnapshotOut<typeof MondayStore>
